import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LatestNews from '../components/LatestNews';
import { gradeCards } from '../data/dummyData';
import './HomePage.css';

const HomePage = () => {
  const [backToTopVisible, setBackToTopVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setBackToTopVisible(true);
      } else {
        setBackToTopVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <>
      {/* Back to Top Button */}
      <button 
        className={`scroll-top-button ${backToTopVisible ? 'visible' : ''}`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Back to top"
      >
        ↑
      </button>
      
      {/* Main Content Grid Layout */}
      <div className="page-layout-container">
        <div className="main-content-area">
          {/* Grade Selection Section */}
          <section className="grade-selection-section">
            <div className="section-header-container">
              <h2 className="section-main-title">Select Grade Level</h2>
              <p className="section-description">
                Choose your grade to access curated CBC resources
              </p>
            </div>
            
            <div className="grade-cards-container">
              {gradeCards.map((grade) => (
                <Link 
                  to={grade.path} 
                  key={grade.id} 
                  className="grade-card-link-wrapper"
                >
                  <div className="grade-card-item">
                    {/* Simple Image Display */}
                    <div 
                      className="grade-card-image-container"
                      style={{ 
                        backgroundImage: `url(${grade.image})`
                      }}
                    ></div>
                    
                    {/* Minimal Content */}
                    <div className="grade-card-content-area">
                      <div className="grade-info-container">
                        <span className="grade-name" style={{ color: grade.color }}>
                          {grade.grade}
                        </span>
                        <p className="grade-summary">{grade.description}</p>
                      </div>
                      
                      {/* Simple CTA */}
                      <div className="grade-action-area">
                        <span className="action-button-text">View Resources →</span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        </div>
        
        {/* Sidebar with Latest News */}
        <aside className="news-sidebar">
          <LatestNews />
        </aside>
      </div>
      
      {/* Features Section - Now properly centered outside the grid layout */}
      <section className="features-main-section">
        <div className="features-header-container">
          <h2 className="features-main-title">Why Choose CBC Center?</h2>
          <p className="features-subtitle">
            We provide the most comprehensive CBC learning experience
          </p>
        </div>
        
        {/* Professional Features Grid */}
        <div className="features-grid-container">
          <div className="feature-card">
            <div className="feature-icon-container">
              <span className="feature-icon">📚</span>
            </div>
            <div className="feature-card-content">
              <h3 className="feature-card-title">Comprehensive Curriculum</h3>
              <p className="feature-card-description">
                Full coverage of CBC syllabus with up-to-date content aligned with national standards.
              </p>
            </div>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon-container">
              <span className="feature-icon">🎯</span>
            </div>
            <div className="feature-card-content">
              <h3 className="feature-card-title">Expert Quality</h3>
              <p className="feature-card-description">
                Resources developed and reviewed by certified educators and curriculum experts.
              </p>
            </div>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon-container">
              <span className="feature-icon">🆓</span>
            </div>
            <div className="feature-card-content">
              <h3 className="feature-card-title">Free Forever</h3>
              <p className="feature-card-description">
                All learning materials are completely free for students, teachers, and parents.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;